import React from "react";
import Resume from "../../assets/DhungelAman-Resume.pdf" 
// import CV from "../../assets/cv.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={Resume} className="btn" download={Resume}>
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
